/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FindEmploymentTokensRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {FindTokensResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const findEmploymentTokens = (request: FindEmploymentTokensRequest, options?: CashRequestOptions) => post<FindEmploymentTokensRequest, FindTokensResponse>("/2.0/cash/find-employment-tokens", request, {...options, rejectOnError: true })